import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

import {
  GetAllImportMutasiBank,
  reset,
} from "../../../features/importMutasiBank/ImportMutasiBankSlice";

import {
  Card,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  faSearch,
  faEye,
  faFileImport,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import axios from "axios";
import BASE_URL from "../../../api";
import PaginationComponent from "../../../components/admin/PaginationComponent";
import { formatToRupiah } from "../../../helpers/helper";

const ListImportMutasiBankPage = () => {
  const sortByList = [
    {
      id: "created_at",
      name: "Tanggal Dibuat",
    },
    {
      id: "description",
      name: "Deskripsi",
    },
  ];

  const sortTypeList = [
    {
      id: "ASC",
      name: "Paling Awal",
    },
    {
      id: "DESC",
      name: "Paling Akhir",
    },
  ];

  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [sortType, setSortType] = useState("DESC");
  const [row, setRow] = useState("10");
  const [page, setPage] = useState("1");

  const fileVerifInputRef = useRef(null);

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.importMutasiBank);

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchDataListImportMutasiBank();
  }, [dispatch, token, page, query, sortBy, sortType, row]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchDataListImportMutasiBank();
  };

  const fetchDataListImportMutasiBank = () => {
    dispatch(reset());
    dispatch(
      GetAllImportMutasiBank({
        token: `${token}`,
        query: `?pageNumber=${page}&q=${query}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
      })
    );
  };

  const handlePagination = (item) => {
    setPage(item);
  };

  const onClickImport = async (file) => {
    if (file) {
      try {
        showLoadingDialog();
        const formData = new FormData();
        formData.append("file", file); // 'file' should match the backend key that accepts the file

        await axios.post(
          `${BASE_URL}/mutasi_bank/import_mutasi`,
          formData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        hideLoadingDialog();
        showSuccessDialog({
          title: "Berhasil!",
          msg: "Berhasil mengimport data!",
        });
        fetchDataListImportMutasiBank();
      } catch (error) {
        console.log("ERROR", error);
        hideLoadingDialog();
        showFailedDialog({
          title: "Oops!",
          msg: error?.response?.data?.message || "Gagal menyimpan data!",
        });
      }
    }
  };

  return (
    <AdminLayout>
      <Header title="Mutasi Bank">
        <Form.Control
          ref={fileVerifInputRef}
          onChange={(event) => onClickImport(event.target.files[0])}
          type="file"
          className="d-none"
          accept=".xlsx,.xls"
        />
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => {
            fileVerifInputRef.current.click();
          }}
        >
          <FontAwesomeIcon icon={faFileImport} className="me-2" />
          Import
        </Button>
      </Header>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between">
              <form onSubmit={handleSearch}>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </InputGroup>
              </form>
              <div className="d-flex gap-3">
                <Form.Group>
                  <Form.Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    {sortByList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    value={sortType}
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    {sortTypeList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table
            responsive
            striped
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                <th className="border-0">Tanggal Transaksi</th>
                <th className="border-0">Deskripsi</th>
                <th className="border-0">Debet</th>
                <th className="border-0">Kredit</th>
                <th className="border-0">Balance</th>
                <th className="border-0">Tanggal</th>
                <th className="border-0">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <th colSpan="8" style={{ textAlign: "center" }}>
                    Loading
                  </th>
                </tr>
              ) : (data?.items || []).length > 0 ? (
                data?.items?.map((item, i) => (
                  <tr key={item.id}>
                    <th>{((page-1)*10) + (i + 1)}</th>
                    <th>
                      {moment(item.datetime).format("DD MMM YYYY HH:mm:ss")}
                    </th>
                    <th>{item.description}</th>
                    <th>{formatToRupiah(item.debit) || "0"}</th>
                    <th>{formatToRupiah(item.credit) || "0"}</th>
                    <th>{formatToRupiah(item.balance) || "0"}</th>
                    <th>
                      {moment(item.created_at).format("DD MMM YYYY HH:mm:ss")}
                    </th>
                    <th>
                      <ButtonGroup size="sm">
                        <Button as={Link} to={`/mutasi-bank/detail/${item.id}`}>
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                      </ButtonGroup>
                    </th>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan="8" style={{ textAlign: "center" }}>
                    Tidak ada data!
                  </th>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <Form.Group>
                <Form.Select
                  placeholder="Row"
                  value={row}
                  onChange={(e) => setRow(e.target.value)}
                >
                  <option defaultValue="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </Form.Group>

              <PaginationComponent
                meta={data?.meta}
                handlePagination={(item) => handlePagination(item)}
              />
            </div>
          </div>
        </Card.Footer>
      </Card>
    </AdminLayout>
  );
};

export default ListImportMutasiBankPage;
